import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('ServiceWorker registered:', registration.scope);
        
        // Force immediate update check
        registration.update();
        
        // If a new SW is waiting, tell it to activate immediately
        if (registration.waiting) {
          registration.waiting.postMessage('skipWaiting');
        }
        
        // Listen for new service worker
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'activated') {
                // New SW activated - reload to get fresh content
                console.log('New ServiceWorker activated, refreshing...');
              }
            });
          }
        });
        
        // Check for updates every 30 seconds
        setInterval(() => {
          registration.update();
        }, 30000);
      })
      .catch((error) => {
        console.log('ServiceWorker registration failed:', error);
      });
  });
}
